import { formatMoney } from 'theme';
import { getProductTitleParts } from 'swatches';
import { getBrand } from '../_getBrand';
import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);
const b2b = document.body.dataset.b2b;
const brand = getBrand();

function priceOutput(item, b2b) {
  // b2b customer
  if (b2b) {
    return html`
      <span class="ac-price">View Product for Special Pricing</span>`;

  // not b2b, item is on sale
  } else if (item.compare_at_price > item.price) {
    return html` 
      <span class="ac-compare-at-price line-through">
        <span class="sr-only">Regular price:</span>
        ${formatMoney(item.compare_at_price * 100)}
      </span>
      <span class="ac-sale-price text-on-sale">
        <span class="sr-only">Sale price:</span>
        ${formatMoney(item.price * 100)}
      </span>`;

  // not b2b, regular price
  } else {
    return html`
      <span class="ac-price">${formatMoney(item.price * 100)}</span>`;
  }
}

export function productCardTemplate(item, b2b) {
  const [title, color] = getProductTitleParts(item.title);
  // Modern Ambition splits variant color out after the title, matching the
  // `show_colorname` markup in product-card.liquid (.product-title__garment /
  // .product-title__color). The color part carries the garment title as a
  // prefix (e.g. "T-Shirt Black"), so strip it back out for display.
  const showColor = brand === 'ma' && Boolean(color);
  const publicColor = showColor ? color.replace(title, '').trim() : null;

  return html`
    <a href="/products/${item.handle}" class="ac-product-card">
      <img src="${item.image}" alt="" loading="lazy" />
      <span class="ac-product-card__title">
        ${showColor ? html`<span class="product-title__garment">${title}</span><span class="product-title__color"><span class="sr-only"> - </span>${publicColor}</span>` : title}
      </span>
      <span class="sr-only">, Price: </span>
      <span class="ac-product-card__price">${priceOutput(item, b2b)}</span>
    </a>
  `;
}